<template>
  <div
    class="wrapper pl50 pr50 mb50"
    style="position: relative; top: 16px;"
    :class="{'items-4' : (steps > 3), 'items-5' : (steps > 4)}"
  >
    <!-- Render all item as inactive by default
      used in checkout process -->
    <div  v-if="shouldCheckCartItems">
      <div class="indicators">
        <span v-for="step in steps" v-bind:key="step">
          <label
            class="step"
            :class="{'active' : (step === activeStep && cartItems > 0) || (activeStep > step && cartItems > 0)}">
            {{ step }}
          </label>
          <br>
          <label
            v-if="showLabel"
            class="step-label"
            :class="{'active' : (step === activeStep && cartItems > 0) || (activeStep > step && cartItems > 0) }"
          >
            {{ labels[--step] }}
          </label>
        </span>
      </div>
      <div class="bars">
        <div
          v-for="step in bars"
          v-bind:key="step"
          :class="{'active' : (activeStep - step >= 1)}"
        >
        </div>
      </div>
    </div>

    <!-- Render first step as active by default
      used in topup and other similar process -->
    <div v-if="!shouldCheckCartItems">
      <div class="indicators">
        <span v-for="step in steps" v-bind:key="step">
          <label
            class="step"
            :class="{'active' : (step === activeStep) || (activeStep > step)}">
            {{ step }}
          </label>
          <br>
          <label
            v-if="showLabel"
            class="step-label"
            :class="{'active' : (step === activeStep) || (activeStep > step) }"
          >
            {{ labels[--step] }}
          </label>
        </span>
      </div>
      <div class="bars">
        <div
          v-for="step in bars"
          v-bind:key="step"
          :class="{'active' : (activeStep - step >= 1)}"
        >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        bars: this.steps - 1
      }
    },
    props: [
      'steps',
      'activeStep',
      'labels',
      'showLabel',
      'cartItems',
      'shouldCheckCartItems'
    ]
  }
</script>

<style scoped>
  .step-label {
    font-style: normal;
  }
  .indicators,
  .bars {
    width: 100%;
    display: flex;
    justify-content: space-between;
  }
  .indicators {
    position: relative;
    z-index: 2;
  }
  .indicators span .step {
    margin: 0;
    margin-bottom: 6px;
    padding: 5px 10px;
    border-radius: 99999px;
    color: #ddd;
    border: 2px solid #ddd;
    background-color: #fff;
  }
  .indicators span .step-label {
    position: absolute;
    padding: 0;
    margin: 0;
    font-weight: normal;
    color: #ddd;
  }
  .indicators span:first-child .step {
    margin-left: 0.8em;
  }
  .indicators span:last-child .step-label {
    /*margin-left: -40px;*/
    margin-bottom: 0;
    padding-bottom: 0;
  }
  .indicators span .step.active {
    color: #428bca;
    border: 2px solid #428bca;
  }
  .indicators span .step-label.active {
    color: #428bca;
  }
  .bars {
    position: relative;
    top: -22px;
    z-index: 1;
  }
  .bars div {
    width: 45%;
    height: 2px;
    background: #ddd;
  }
  .bars div:first-child {
    margin-left: 20px;
  }
  .bars div:last-child {
    margin-right: 20px;
  }
  .bars div.active {
    background-color: #428bca;
  }
  /* Adjust labels when indicator contains 4 items */
  /*.wrapper.items4 .labels label:nth-child(2) {
    margin-left: -2px;
  }
  .wrapper.items4 .labels label:nth-child(3) {
    margin-right: -12px;
  }*/
</style>



// WEBPACK FOOTER //
// src/components/StepIndicator.vue